/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ to: NonNullable<unknown> }} Order_Payment_Method_Change_ConfirmInputs */

const vi_order_payment_method_change_confirm = /** @type {(inputs: Order_Payment_Method_Change_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đổi sang ${i?.to}`)
};

/**

* @param {Order_Payment_Method_Change_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_confirm = /** @type {((inputs: Order_Payment_Method_Change_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_confirm(inputs)
});